import { PoolSubject } from 'libs/end-to-end/src/copilot';
import { useCallback } from 'react';
import { Setter } from 'libs/end-to-end/src/ui-types';
import { SetterWithReducer } from 'libs/end-to-end/src/ui-types';

export type BasicCopilotRemoveFromSlateFn = (subject: PoolSubject) => void;

export const useBasicCopilotRemoveFromSlate = ({
  setSelectedSlateIds,
}: {
  setSelectedSlateIds: SetterWithReducer<string[]>;
}): BasicCopilotRemoveFromSlateFn => {
  return useCallback(
    (subject: PoolSubject) => {
      const id = subject.id;

      setSelectedSlateIds((current) => {
        if (!current) {
          return [];
        }

        return current.filter((subjectId) => subjectId !== id);
      });
    },
    [setSelectedSlateIds],
  );
};
